import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            "filterByInstitutionType": "Filter by Institution Type",
            "Alle": "All",
            "Physiotherapie": "Physiotherapy",
            "Ergotherapie": "Ergotherapy",
            "Physio- & Ergotherapie" : "Physio- & Ergotherapy",
            "Sonstige": "Other",
            "Akutklinik": "Acute Clinic",
            "Rehaklinik": "Rehab Clinic",
            "Klinik": "Clinic",
            "Adresse": "Address",
            "Kontakt": "Contact",
            "Webseite": "Website",
            "Tel": "Phone",
        }
    },
    de: {
        translation: {
            "filterByInstitutionType": "Filtern nach Art der Institution",
            "Alle": "Alle",
            "Physiotherapie": "Physiotherapie",
            "Ergotherapie": "Ergotherapie",
            "Sonstige": "Sonstige",
            "Akutklinik": "Akutklinik",
            "Rehaklinik": "Rehaklinik",
            "Klinik": "Klinik",
            "Adresse": "Adresse",
            "Kontakt": "Kontakt",
            "Webseite": "Webseite",
            "Tel": "Tel",
        }
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: navigator.language || 'en', // default language based on the browser's language
    fallbackLng: 'en', // fallback language
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});

export default i18n;
